import { TourDefinition } from './types'
import { welcomeToStudioTour } from './definitions/welcome-to-studio.tour'
import { toursIntroTour } from './definitions/tours-intro.tour'
import { notificationPreferencesTour } from './definitions/notification-preferences.tour'
import { sidebarNavigationTour } from './definitions/sidebar-navigation.tour'
// TODO: uncomment when Create V5 launches
// import { createCourseTour } from './definitions/create-course.tour'
// import { editCourseTour } from './definitions/edit-course.tour'
// import { seriesTour } from './definitions/series.tour'
// import { editSeriesTour } from './definitions/edit-series.tour'
// import { videoLibraryTour } from './definitions/video-library.tour'
// import { showNotesLibraryTour } from './definitions/show-notes-library.tour'
// import { quizLibraryTour } from './definitions/quiz-library.tour'

// Tour registry — the single source of truth for all tours in the app.
// To add a new tour:
//   1. Follow the agentic workflow in README.md (Playwright exploration first)
//   2. Create a definition file in ./definitions/<tour-id>.tour.ts
//   3. Import it here and add it to the array below
// Array order determines auto-play priority on the self-paced page.
export let tourRegistry: TourDefinition[] = [
  welcomeToStudioTour,
  toursIntroTour,
  notificationPreferencesTour,
  sidebarNavigationTour,
  // TODO: uncomment when Create V5 launches
  // createCourseTour,
  // editCourseTour,
  // seriesTour,
  // editSeriesTour,
  // videoLibraryTour,
  // showNotesLibraryTour,
  // quizLibraryTour,
]

export let getTourByID = (id: string): TourDefinition | undefined =>
  tourRegistry.find((t) => t.id === id)
